module.exports = __webpack_public_path__ + "web/img/p1.9b0c8a21.png";